// extracted by mini-css-extract-plugin
export default {"layerButton":"KQUNE","greyedIcon":"GB7Zr","label":"X2Dhq","modeButton":"LSmSY","disabledLayerButton":"bad5b","disabledLabel":"kcmFW","activeButton":"pQh_d"};